var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-of-directors"},[_c('div',{staticClass:"u-top-margin--l-desktop u-bottom-margin--l-desktop"},[_c('z-caption',{attrs:{"weight":"700"},domProps:{"innerHTML":_vm._s(_vm.text.p)}})],1),_vm._v(" "),_c('bods',{attrs:{"data":_vm.boardOfDirectors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }